// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__te2p1","default":"Icon_default__1C_4x","md":"Icon_md__2rg_q","xl":"Icon_xl__1PgNQ"};